import { Router, RouterModule } from "@angular/router";
import { Component, ElementRef, inject, ViewChild } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { GoogleSignInComponent } from "../google-signin/google-signin.component";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { AppleSignInComponent } from "../apple-signin/apple-signin.component";
import { CommonModule } from "@angular/common";
import { AuthService } from "../../core/services/auth.service";
import { LoginForm } from "../../shared/data-types/login-form";
import { NotificationService } from "../../shared/components/notification/notification.service";
import { AuthStore } from "../../shared/store/auth.store";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
  selector: "app-login",
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    GoogleSignInComponent,
    AppleSignInComponent,
    ReactiveFormsModule,
    MatCheckboxModule,
    CommonModule,
    RouterModule,
  ],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
})
export class LoginComponent {
  @ViewChild("buttonDiv", { static: false }) buttonDiv!: ElementRef;
  @ViewChild("googleBtn", { static: false }) googleBtn!: ElementRef;

  authStore = inject(AuthStore);

  loginForm: FormGroup;
  isSubmitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService
  ) {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]],
    } as { [K in keyof LoginForm]: any });
  }

  login() {
    if (this.loginForm.invalid) return;

    this.isSubmitting = true;
    const loginForm: LoginForm = this.loginForm.value;

    this.authService.loginUser(loginForm).subscribe({
      next: (response) => {
        this.authService.handleLoginSuccess(response.token);

        if (this.authService.isAuthenticated()) {
          this.notificationService.showNotification(undefined, "Login successful!", true);
          this.router.navigate(["/market"]);
        } else {
          this.notificationService.showNotification(undefined, "Invalid token. Please login again.", false);
        }
      },
      error: (error) => {
        this.notificationService.showNotification(error);
      },
      complete: () => {
        this.isSubmitting = false;
      },
    });
  }
}
